// src/screens/WithdrawFundsScreen.jsx
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import apiClient from "../api/apiClient";
import walletSvg from "../assets/icons/walletCard.png";
import mcLogo from "../assets/icons/mastercard-svgrepo-com.svg";
import gpayLogo from "../assets/icons/google-pay-or-tez-logo-svgrepo-com.svg";
import phonepeLogo from "../assets/icons/phonepe-icon.svg";
import paytmLogo from "../assets/icons/paytm_icon-icons.com_62778.svg";
import bankLogo from "../assets/icons/banking.png";
import "../css/mainhome.css";
import "../css/WithdrawFunds.css";
import { toast } from "react-toastify";

const payoutOptions = [
  { id: "gpay", label: "Google Pay", logo: gpayLogo },
  { id: "phonepe", label: "PhonePe", logo: phonepeLogo },
  { id: "paytm", label: "Paytm", logo: paytmLogo },
  { id: "bank", label: "Bank Account", logo: bankLogo },
];

const upiPlaceholder = {
  gpay: "Enter GPay Number",
  phonepe: "Enter PhonePe Number",
  paytm: "Enter Paytm Number",
};

export default function WithdrawFundsScreen() {
  const walletBalance = localStorage.getItem("walletBalance");
  const nav = useNavigate();

  const [method, setMethod] = useState("gpay");
  const [isLoading, setIsLoading] = useState(false);
  const [minWithdraw, setMinWithdraw] = useState(0);

  const [form, setForm] = useState({
    amount: "",
    paytmNo: "",
    bankName: "",
    accHolder: "",
    accNo: "",
    ifsc: "",
  });

  useEffect(() => {
    const feeSettings = localStorage.getItem("feeSettings");
    if (feeSettings) {
      try {
        const parsed = JSON.parse(feeSettings);
        if (parsed.minWithdraw) {
          setMinWithdraw(Number(parsed.minWithdraw));
        }
      } catch (err) {
        console.error("Error parsing feesettings:", err);
      }
    }
  }, []);

  const onChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async () => {
    if (Number(form.amount) < minWithdraw) {
      toast.error(`Minimum withdrawal is ₹${minWithdraw}`);
      return;
    }

    setIsLoading(true);

    const registerId = localStorage.getItem("registerId");

    let payload = {
      registerId,
      amount: Number(form.amount),
    };

    if (method === "bank") {
      payload.withdrawType = "bank";
      payload.bankName = form.bankName;
      payload.accountHolderName = form.accHolder;
      payload.accountNumber = form.accNo;
      payload.ifscCode = form.ifsc;
    } else {
      const typeMapping = {
        gpay: "googlePay",
        phonepe: "phonePe",
        paytm: "paytm",
      };

      payload.withdrawType = typeMapping[method];
      payload.upiId = form.paytmNo;
    }

    try {
      const response = await apiClient.post(
        "/withdraw-fund-request",
        payload
      );

      toast.warn(response.data.msg);

      if (response.data.status) {
        nav(-1);
      }
    } catch (error) {
      console.error("Withdrawal request failed:", error);
      toast.error("An error occurred. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="mainhome-screen-wrapper">
      <div className="withdraw-page">
        <header className="withdraw-header">
          <button className="back-btn" onClick={() => nav(-1)}>‹</button>
          <h2>Withdraw Funds</h2>
        </header>

        <div className="withdraw-body">
          <section className="wallet-card">
            <div className="card-toop">SARA777</div>
            <div className="card-body">
              <img src={walletSvg} alt="" className="card-wallet-icon" />
              <div>
                <div className="card-balance-label">{walletBalance}</div>
                <div className="card-balance-text">Current Balance</div>
              </div>
              <img src={mcLogo} alt="" className="card-mc" />
            </div>
          </section>

          <div className="payout-list">
            {payoutOptions.map((opt) => (
              <label
                key={opt.id}
                className={`payout-item ${method === opt.id ? "active" : ""}`}
              >
                <div className="payout-info">
                  <img src={opt.logo} alt="" className="payout-logo" />
                  <div>
                    <div className="payout-label">{opt.label}</div>
                    <div className="payout-note">Manual approve by Admin</div>
                  </div>
                </div>

                <input
                  type="radio"
                  name="payout"
                  value={opt.id}
                  checked={method === opt.id}
                  onChange={() => setMethod(opt.id)}
                />
                <span className="custom-radio" />
              </label>
            ))}
          </div>

          <form
            className="withdraw-form"
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit();
            }}
          >
            <input
              name="amount"
              type="number"
              placeholder={`Enter Amount (Min ₹${minWithdraw})`}
              value={form.amount}
              onChange={onChange}
              required
            />

            {method !== "bank" && (
              <input
                name="paytmNo"
                placeholder={upiPlaceholder[method]}
                value={form.paytmNo}
                onChange={onChange}
                required
              />
            )}

            {method === "bank" && (
              <>
                <input
                  name="bankName"
                  placeholder="Bank Name"
                  value={form.bankName}
                  onChange={onChange}
                  required
                />
                <input
                  name="accHolder"
                  placeholder="Account Holder Name"
                  value={form.accHolder}
                  onChange={onChange}
                  required
                />
                <input
                  name="accNo"
                  placeholder="Account Number"
                  value={form.accNo}
                  onChange={onChange}
                  required
                />
                <input
                  name="ifsc"
                  placeholder="IFSC Code"
                  value={form.ifsc}
                  onChange={onChange}
                  required
                />
              </>
            )}

            <button type="submit" disabled={isLoading}>
              {isLoading ? "SUBMITTING..." : "SUBMIT"}
            </button>
          </form>

          <div className="help-box">
            For withdraw related queries call<br />
            or WhatsApp<br />
            <strong>Monday to Sunday • 9:00 AM – 6:00 PM</strong>
          </div>
        </div>
      </div>
    </div>
  );
}